import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_AddLinkToPDF } from "./XML_AddLinkToPDF";

export function XML_DrawLargeSubchartArrowPDF(
  x0,
  x1,
  x2,
  x3,
  x4,
  y0,
  y1,
  y2,
  fillColor,
  drawElement,
  linkBookmark,
  layer
) {
  if (!drawElement.fIncludeSCArrows || linkBookmark == null) return;

  x0 = XML_ScaleAndShiftX(x0, drawElement, layer);
  x1 = XML_ScaleAndShiftX(x1, drawElement, layer);
  x2 = XML_ScaleAndShiftX(x2, drawElement, layer);
  x3 = XML_ScaleAndShiftX(x3, drawElement, layer);
  x4 = XML_ScaleAndShiftX(x4, drawElement, layer);

  y0 = XML_ScaleAndShiftY(y0, drawElement, layer);
  y1 = XML_ScaleAndShiftY(y1, drawElement, layer);
  y2 = XML_ScaleAndShiftY(y2, drawElement, layer);

  y0 = drawElement.ConvertY(y0);
  y1 = drawElement.ConvertY(y1);
  y2 = drawElement.ConvertY(y2);

  drawElement.DrawLargeArrow(x0, y0, x1, y1, x2, y2, x3, x4, fillColor);

  XML_AddLinkToPDF(x0, y0, x1, y1, x2, y2, x3, x4, drawElement, linkBookmark);
}
